import { SolanaBaseCommand } from './BaseCommand';

export abstract class SolanaWithoutSignerBaseCommand extends SolanaBaseCommand {
  static flags = {
    ...SolanaBaseCommand.flags,
  };

  async init() {
    await super.init();
  }
}
